/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTicketSubsidyDto } from '../../models/create-ticket-subsidy-dto';
import { TicketSubsidyDto } from '../../models/ticket-subsidy-dto';

export interface TicketSubsidyControllerForceCreate$Params {
  ticketId: string;
  centerUserId?: string;
      body: CreateTicketSubsidyDto
}

export function ticketSubsidyControllerForceCreate(http: HttpClient, rootUrl: string, params: TicketSubsidyControllerForceCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketSubsidyDto>> {
  const rb = new RequestBuilder(rootUrl, ticketSubsidyControllerForceCreate.PATH, 'post');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
    rb.query('centerUserId', params.centerUserId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketSubsidyDto>;
    })
  );
}

ticketSubsidyControllerForceCreate.PATH = '/api/ticket-subsidy/force';
